import {
  TYPEMANAGELIST} from 'actions/deviceTypeManage';
import {reducerPackage} from "../../utils";

export const deviceTypeManageList = reducerPackage(TYPEMANAGELIST);

